import appleIcon from '@/assets/logos/apple.svg';
import googleIcon from '@/assets/logos/google-color.svg';
import {
  KINDE_APPLE_CONNECTION_ID,
  KINDE_GMAIL_CONNECTION_ID,
} from '@/components/constants/kinde';
import { isAppleSignInAvailable } from '@/utils/appConfiguration';

import { signUpFormMessages } from './SignUpForm.messages';

const GOOGLE_SOCIAL_PROVIDER = {
  id: 'google',
  connectionId: KINDE_GMAIL_CONNECTION_ID,
  icon: googleIcon,
  labelMessage: signUpFormMessages.continueWithGoogle,
  logoAltMessage: signUpFormMessages.googleLogoAlt,
} as const;

const APPLE_SOCIAL_PROVIDER = {
  id: 'apple',
  connectionId: KINDE_APPLE_CONNECTION_ID,
  icon: appleIcon,
  labelMessage: signUpFormMessages.continueWithApple,
  logoAltMessage: signUpFormMessages.appleLogoAlt,
} as const;

export function getSocialProviders() {
  return [
    GOOGLE_SOCIAL_PROVIDER,
    ...(isAppleSignInAvailable() ? [APPLE_SOCIAL_PROVIDER] : []),
  ] as const;
}
